// extracted by mini-css-extract-plugin
export default {"product__section":"_products_product__section__rTjjM"};